
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLoop as ObiLoopElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-loop.js';
 
 
 

 
 export const ObiLoop = createComponent({
   react: React,
   tagName: 'obi-loop',
   elementClass: ObiLoopElement,
   events: {
     
   }
  });
 
 